export default __webpack_public_path__ + "static/media/Img0024.ef018e58.jpg";